const toCurrencyUnicodeMap = {
  USD: '\u0024',
  AUD: '\u0024',
  GBP: '\u00A3',
  CAD: '\u0024',
  EUR: '\u20AC',
  INR: '\u20B9',
  JPY: '\u00A5',
  NZD: '\u0024',
  RMB: '\u00A5',
  CHF: '\u20A3',
  BRL: '\u0052\u0024',
}

export { toCurrencyUnicodeMap }
